mutation UnEndEvent($eventId: ID!) {
  event: StreamToolsUnEndEvent(eventId: $eventId) {
    eventId
    status
    endedAt
  }
}
